import React from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import ActionLink from "./ActionLink";
import useTranslationCommon from "../useTranslationCommon";
import useShowLoader from "../loading-widgets/useShowLoader";
import useClearApolloStore from '../../infra-no-ui/apollo/useClearApolloStore';

export default function RefreshButton() {
  const { t, loading: tLoading } = useTranslationCommon();
  const { clearApolloStore, loading } = useClearApolloStore();

  useShowLoader(tLoading);

  return (
    <ActionLink onClick={clearApolloStore} loading={loading}>
      <RefreshIcon />
      {t("common:common_refresh_label")}
    </ActionLink>
  );

}
